<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 60 60"
    aria-hidden="true"
  >
    <path d="M26,26H0V0h26V26z M1,25h24V1H1V25z"/>
    <path d="M60,26H34V0h26V26z M35,25h24V1H35V25z"/>
    <path d="M60,60H34V34h26V60z M35,59h24V35H35V59z"/>
    <path d="M26,60H0V34h26V60z M1,59h24V35H1V59z"/>
  </svg>
</template>

<script>
export default {
  name: 'LoadingIcon',
};
</script>

<style lang="scss" scoped>
@use "sass:math";

svg {
  overflow: visible;
}

$items: 4;
$duration: 2100ms;
@for $i from 1 through $items {
  path:nth-child(#{$i}) {
    opacity: 0;
    fill: var(--colors-main-font);
    transform-origin: center;
    animation: loading-animation $duration infinite;
    animation-delay: $i * math.div($duration, (math.div($items, 0.3)));
  }
}

@keyframes loading-animation {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  20% {
    opacity: 1;
    transform: scale(1);
  }
  40% {
    opacity: 0;
    transform: scale(0.97);
  }
  60% {
    opacity: 0;
    transform: scale(0.97);
  }
  90% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
